import Utils from "@/utils/util";
import { createI18n } from "vue-i18n";

import * as XLSX from "xlsx";
const defaultLangConfig = {
  pt: "pt",
  en: "en",
  cn: "zh-Hans"
};
async function fetchConfig() {
  try {
    const origin = window.location.origin;
    const isDev = import.meta.env.MODE === "development";
    const isTest = import.meta.env.MODE === "test";
    const isPro = import.meta.env.MODE === "production";
    
    // 开发和测试环境使用本地配置，生产环境使用线上配置
    const configPath = (isDev || isTest) 
      ? `/config.json`
      // : `https://api.b3337.com/uploads/config.json`;
      : `${origin}/config/config.json`;
    // console.log('当前环境:', import.meta.env.MODE);
    // console.log('配置文件路径:', configPath);

    const response = await fetch(configPath);
    // console.log(response)
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const configData = await response.json();
    return configData;
  } catch (error) {
    console.error("Failed to fetch configuration:", error);
    return null;
  }
}

async function initConfig() {
  try {
    const externalConfig = await fetchConfig();
    const langConfig = externalConfig ? externalConfig : defaultLangConfig;
    // console.log(langConfig);
    Utils.$storageSet("langConfig", langConfig);
    // 语言开关是否打开
    const currentUrl = window.location.href;
    const langMatch = currentUrl.match(/\/(en|cn|fr|es|pt)\b/);
    const getLanguageOpen = () => {
      return langMatch ? false : true;
    };
    const getLanguageDefault = () => {
      return langMatch ? langConfig[langMatch[1]] : langConfig["pt"];
    };

    const config = {
      UNIT: "R$",
      AREA_CODE: "+55",
      LANGUAGE_OPEN: getLanguageOpen(),
      LANGUAGE_DEFAULT:  getLanguageDefault()
    };
    // console.log(config);
    Utils.$storageSet("config", config);

    // 如果需要导出或全局使用 config，可以在此处返回 config
    return config;
  } catch (error) {
    console.error("Error initConfig:", error);
    throw error;
  }
}

// 加载语言包xlsx文件请求
async function loadLanguages() {
  try {
    const origin = window.location.origin;
    const isDev = import.meta.env.MODE === "development";
    const isTest = import.meta.env.MODE === "test";

    // 统一路径处理逻辑
    const xlsxPath = (isDev || isTest)
      ? new URL(`/language.xlsx`, import.meta.url)
      // : new URL(`https://api.b3337.com/uploads/language.xlsx`);
      : new URL(`${origin}/config/language.xlsx`);
    
    // console.log('当前环境:', import.meta.env.MODE);
    // console.log('语言文件路径:', xlsxPath);

    const response = await fetch(xlsxPath);
    const data = await response.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });

    const messages = {};
    const keys = new Set(); // 存储所有的key
    const languages = [];

    workbook.SheetNames.forEach(sheetName => {
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      // console.log(jsonData)
      jsonData.forEach(row => {
        keys.add(row.key); // 收集所有的key
        for (const [key, value] of Object.entries(row)) {
          if (key !== "key") {
            if (!messages[key]) {
              messages[key] = {};
            }
            messages[key][row.key] = value;
          }
        }
      });
    });

    // 确保每个key在所有语言中都有值
    keys.forEach(key => {
      for (const lang of Object.keys(messages)) {
        if (!messages[lang][key]) {
          messages[lang][key] = ""; // 默认为空字符串
        }
      }
    });
    for (const lang of Object.keys(messages)) {
      languages.push({
        key: lang
      });
    }
    // console.log(messages,languages)
    return { messages, languages };
  } catch (error) {
    console.error("Error loadLanguages:", error);

    throw error;
  }
}

let i18nInstance = null; // 用于缓存 i18n 实例
// 创建多语言实例
async function createI18nInstance() {
  if (i18nInstance) {
    // 如果已经创建了 i18n 实例，直接返回缓存的实例
    return i18nInstance;
  }
  try {
    const { messages, languages } = await loadLanguages();
    const getLanguageDefault = () => {
      const currentUrl = window.location.href;
      const langMatch = currentUrl.match(/\/(en|cn|fr|es|pt)\b/);
      const langConfig = Utils.$storageGet("langConfig");
      // console.log(langConfig);
      return langMatch ? langConfig[langMatch[1]] : langConfig["pt"];
    };
    Utils.$storageSet("langs", languages);
    // console.log(messages);
    // console.log(Utils.$storageGet("lang"),Utils.$storageGet("config").LANGUAGE_DEFAULT);
    // locale: JSON.parse(localStorage.getItem("lang")) || "zh-Hans", // 默认语言
    // locale:"zh-Hans", // 默认语言
    i18nInstance = createI18n({
      locale:  getLanguageDefault(), // 默认语言
      legacy: false,
      messages: messages
    });
    return i18nInstance;
  } catch (error) {
    console.error("Error createI18nInstance:", error);

    throw error;
  }
}

export { initConfig, loadLanguages, createI18nInstance };

// setup使用
// import {useI18n} from 'vue-i18n'
// const {t} = useI18n()

// js文件使用
// import { createI18nInstance } from "@/language";
// const i18n = await createI18nInstance();
// const { t } = i18n.global;
